import styled from 'styled-components';

export default styled.img`
  display: block;
  width: 5.5em;
`;
